The identifiers to correlate the signal back to the SEEK job ads.

Only applicable to position signals.
